import * as React from "react";
import { useState } from "react";
import HeaderBar from "../commons/components/HeaderBar";
import SettingGoogleAnalyticsIntegration, {
  SettingGoogleAnalytics4IntegrationProps,
} from "../settings/SettingGoogleAnalyticsIntegration";
import SettingsWebsiteIntegration from "./SettingsWebsiteIntegration";
import {
  SmileSimulationSettingsForm,
  SmileSimulationSettingsProps,
} from "../SmileSimulationSettings";
import { VirtualConsultationConfiguration } from "./model/Flow";
import { AvailableEntitiesSettings } from "../commons/model/EntitySettings";
import LoadingSpinner from "../flow/utils/LoadingSpinner";
import { createRoot } from "react-dom/client";

export default function SettingsVirtualConsultationIntegration({
  entities,
  virtualConsultationProps,
  smileSimulationSettingsProps,
  googleAnalytics4Props,
  isDmipPlatform,
}: {
  entities: AvailableEntitiesSettings;
  virtualConsultationProps?: VirtualConsultationConfiguration;
  smileSimulationSettingsProps?: SmileSimulationSettingsProps;
  googleAnalytics4Props?: SettingGoogleAnalytics4IntegrationProps;
  isDmipPlatform: boolean;
}) {
  const [loading, setLoading] = useState(false);

  function SmileSimulation() {
    return (
      smileSimulationSettingsProps && (
        <SmileSimulationSettingsForm {...smileSimulationSettingsProps} />
      )
    );
  }

  function GoogleAnalytics() {
    return (
      googleAnalytics4Props && (
        <div className="panel with-shadow v-flex">
          <SettingGoogleAnalyticsIntegration {...googleAnalytics4Props} />
        </div>
      )
    );
  }

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="settings-customisation full-height">
      <HeaderBar
        title={i18n["Page.Settings.VirtualConsultation.Title"]}
        entities={entities}
        onChange={() => {
          setLoading(true);
        }}
      />
      <div className="integration-container">
        <SettingsWebsiteIntegration
          virtualConsultationProps={virtualConsultationProps}
          isDmipPlatform={isDmipPlatform}
        />
        <SmileSimulation />
        <GoogleAnalytics />
      </div>
    </div>
  );
}

SettingsVirtualConsultationIntegration.loadComponent = (elementId: string, props) => {
  const container = document.getElementById(elementId);
  const root = createRoot(container!);
  root.render(<SettingsVirtualConsultationIntegration {...props} />);
};
